<template>
  <v-layout row wrap white>
    <v-flex xs4 ml-5>
      <v-text-field
        v-model="service_name"
        label="Procurar serviço"
        append-icon="search"
        @click:append="search"
        v-on:keydown.enter.prevent="search"
      />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      service_name: ""
    };
  },
  props: {
    searchServices: Function
  },
  methods: {
    search() {
      this.$props.searchServices({ service_name: this.service_name });
    }
  }
};
</script>

<style>
</style>